import { PERMISSIONS } from '@helios/authz';
import { useScopedOperationalMutation, useScopedOperationalQuery } from '@/hooks/useScopedOperationalQuery';
import { launchApi } from './launch.api';

export function useLaunchCommandCenter() {
  return useScopedOperationalQuery('launch', PERMISSIONS.PLATFORM_ADMIN, launchApi.getDashboard, 60_000);
}
export function useRunLaunchSmoke() {
  return useScopedOperationalMutation('launch', PERMISSIONS.PLATFORM_ADMIN, (_input: void, options) => launchApi.runSmoke(undefined, options));
}
